import Fetch from "./index";

export const getDashboard = async (filters) => {
  for (let key in filters) {
    if (!filters[key])
      delete filters[key];
  }

  const filter = new URLSearchParams(filters).toString();

  return Fetch("/dashboard?" + filter)
}

export const loadHome = async (filters) => {
  for (let key in filters) {
    if (!filters[key])
      delete filters[key];
  }

  const filter = new URLSearchParams(filters).toString();

  return Fetch("/dashboard/home?" + filter)
}

export const globalSearch = async (text) => {
  if (!text)
    return Promise.reject("failed to global search");

  return Fetch("/dashboard/search?text=" + text)
}

export const homeNewGraph = async (filters) => {
  for (let key in filters) {
    if (!filters[key])
      delete filters[key];
  }

  const filter = new URLSearchParams(filters).toString();

  return Fetch("/dashboard/graph?" + filter)
}
